import { useCallback, React } from 'react';

const AnswerAlphaNumeric = ({ phrases, questLabels, eventListenTab, keyCount, phase }) => {

    let prevKey = '';
    const handleKeyDown = (e, id) => {
        if ((prevKey !== 'Shift' && e.key === 'Tab') || e.key === 'Enter') {
            eventListenTab(e, id);
        } else if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 48 && e.keyCode <= 57)
            || (e.keyCode >= 186 && e.keyCode <= 190) || (e.keyCode >= 96 && e.keyCode <= 122)) {
            keyCount();
        }
        prevKey = e.key;
    }

    const handlePaste = (event) => {
        event.preventDefault()
    }

    return (
        <div className={`g-item_6 flex_col g2 align-items_start align-items_start shown ${phase}`}>
            <p className="small-title m0">{phrases?.["15267"]}</p>
            <div className="full-width flex_col p4 align-items_start g2 align-self-stretch roundness_1 question-brdr">
                <div className="full-width flex_col justify-content_center align-items_center align-self-stretch g2">
                    <div className="g-item_12 input-wrapper">
                        <label className="caption ">{questLabels[0]}</label>
                        <input className='custom-form-input-tt28' id='input-1' type="text" onKeyDown={(e) => handleKeyDown(e, 1)} onPaste={(event) => handlePaste(event)} />
                    </div>
                    <div className="g-item_12 input-wrapper ">
                        <label className="caption ">{questLabels[1]}</label>
                        <input className='custom-form-input-tt28' type="text" onKeyDown={(e) => handleKeyDown(e, 2)} onPaste={(event) => handlePaste(event)} />
                    </div>
                    <div className="g-item_12 flex g2 align-items_start align-self-stretch flex_col_tablet">
                        <div className="full-width_tablet width_50">
                            <label className="caption ">{questLabels[2]}</label>
                            <input className="min-txt-width custom-form-input-tt28" type="text" onKeyDown={(e) => handleKeyDown(e, 3)} onPaste={(event) => handlePaste(event)} />
                        </div>
                        <div className="full-width_tablet width_50">
                            <label className="caption ">{questLabels[3]}</label>
                            <input className="min-txt-width custom-form-input-tt28" type="text" onKeyDown={(e) => handleKeyDown(e, 4)} onPaste={(event) => handlePaste(event)} />
                        </div>
                    </div>
                    <div className="g-item_12 flex g2 align-items_start align-self-stretch flex_col_tablet">
                        <div className="full-width_tablet width_50">
                            <label className="caption ">{questLabels[4]}</label>
                            <input className="min-txt-width custom-form-input-tt28" type="text" onKeyDown={(e) => handleKeyDown(e, 5)} onPaste={(event) => handlePaste(event)} />
                        </div>
                        <div className="full-width_tablet width_50">
                            <label className="caption ">{questLabels[5]}</label>
                            <input className="min-txt-width custom-form-input-tt28" type="text" onKeyDown={(e) => handleKeyDown(e, 6)} onPaste={(event) => handlePaste(event)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>);
};

export default AnswerAlphaNumeric;